export default __webpack_public_path__ + "static/media/thinking-monkey.a4a6aa83f70f8cbe3f468c30f2dfcad1.jpg";